import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { interfaces } from '@leandredev/dcbm-common-lib';
import { map } from 'rxjs/operators';

import { ThemeService } from '../../../@fury/services/theme.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
@Component({
  selector: 'fury-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Input()
  @HostBinding('class.no-box-shadow')
  hasNavigation: boolean;

  @Output() openSidenav = new EventEmitter();
  @Output() openQuickPanel = new EventEmitter();

  public profile: interfaces.IUserAdmin;

  topNavigation$ = this.themeService.config$.pipe(map((config) => config.navigation === 'top'));

  constructor(private themeService: ThemeService, private profileService: ProfileService) {}

  ngOnInit() {
    this.profileService.profile.subscribe((profile) => {
      this.profile = profile;
    });

    this.profileService
      .getServiceResposabilityForUser()
      .pipe(
        map((v) => {
          this.isManager = !!v;
        })
      )
      .subscribe();
  }

  public isManager = false;
}
